import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import variables from '../../../../../utils/variables';
import CopyButton from '../../../../../components/CopyButton';
import copyIcon from '../../../../../assets/copy.svg';
import { Button } from '@material-ui/core';
import { hideCreateCollectionDialog, setCollection } from '../../../../../actions/createAssets';
import TotalSale from '../../../../CreateCollection/TotalSale';

const Step2 = (props) => {
    const description = props.value && props.value.description;
    const id = props.value && props.value.id;
    const previewUrl = props.value && props.value.preview_uri;
    const schema = props.value && props.value.schema;
    const symbol = (props.value && props.value.symbol) ||
    (props.value && props.value.value && props.value.value.msg && props.value.value.msg.length &&
        props.value.value.msg[0] && props.value.value.msg[0].value && props.value.value.msg[0].value.symbol);
    const name = (props.value && props.value.name) ||
        (props.value && props.value.value && props.value.value.msg && props.value.value.msg.length &&
            props.value.value.msg[0] && props.value.value.msg[0].value && props.value.value.msg[0].value.name);

    const totalSale = {
        details: props.collectionConfirmDialog,
        splitInfo: props.splitValue,
    };

    const handleRedirect = () => {
        props.handleClose();
        if (props.options && props.options.length) {
            props.onChange(props.options[0]);
        }
    };

    return (
        <div className="collection_content step2_collection">
            <div className="heading">
                <h1>{variables[props.lang].congratulations}</h1>
                <p>{variables[props.lang]['congrats_sub_text1']}</p>
                <p>{variables[props.lang]['congrats_sub_text2']}</p>
            </div>
            {symbol
                ? <div className="row">
                    <div className="label_info">
                        <p className="title">{variables[props.lang]['denom_symbol']}</p>
                    </div>
                    <div className="copy_info">
                        <p>{symbol}</p>
                    </div>
                </div> : null}
            {name
                ? <div className="row">
                    <div className="label_info">
                        <p className="title">{variables[props.lang]['denom_name']}</p>
                    </div>
                    <div className="copy_info">
                        <p>{name}</p>
                    </div>
                </div> : null}
            {description &&
                <div className="row">
                    <div className="label_info">
                        <p className="title">{variables[props.lang]['denom_description']}</p>
                    </div>
                    <div className="copy_info">
                        <p>{description}</p>
                    </div>
                </div>}
            <div className="row">
                <div className="label_info">
                    <p className="title">{variables[props.lang]['denom_id']}</p>
                    <p className="title_info">{variables[props.lang]['denom_id_info']}</p>
                </div>
                <div className="copy_info">
                    <p>{id}</p>
                    <CopyButton data={id} icon={copyIcon}/>
                </div>
            </div>
            {previewUrl &&
                <div className="row">
                    <div className="label_info">
                        <p className="title">{variables[props.lang]['denom_preview_url']}</p>
                        <p className="title_info">{variables[props.lang]['denom_preview_url_info']}</p>
                    </div>
                    <div className="copy_info">
                        <p>{previewUrl}</p>
                        <CopyButton data={previewUrl} icon={copyIcon}/>
                    </div>
                </div>}
            {schema &&
                <div className="row">
                    <div className="label_info">
                        <p className="title">{variables[props.lang]['json_schema']}</p>
                        <p className="title_info">{variables[props.lang]['json_schema_info']}</p>
                    </div>
                    <div className="copy_info">
                        <p>{schema}</p>
                    </div>
                </div>}
            {props.splitInfoStatus && props.splitValue &&
                props.splitValue.length &&
                <TotalSale totalSale={totalSale}/>}
            <Button
                className="primary_button"
                variant="contained"
                onClick={handleRedirect}>
                {variables[props.lang].done}
            </Button>
        </div>
    );
};

Step2.propTypes = {
    handleClose: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    splitInfoStatus: PropTypes.bool.isRequired,
    splitValue: PropTypes.array.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    collectionConfirmDialog: PropTypes.object,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        value: state.createAssets.nft.newCollection.value,
        options: state.createAssets.nft.collection.options,

        collectionConfirmDialog: state.createAssets.nft.collectionConfirmDialog.value,
        splitValue: state.collection.denomSplitInfo.value,
        splitInfoStatus: state.collection.denomSplitInfo.status,
        tokenValue: state.createAssets.nft.tokenValue.value,
        tokenPrice: state.createAssets.nft.tokenPrice,
    };
};

const actionToProps = {
    handleClose: hideCreateCollectionDialog,
    onChange: setCollection,
};

export default connect(stateToProps, actionToProps)(Step2);
